import React from 'react';
import Container from '../components/Container.jsx';
import SectionDivider from '../components/SectionDivider.jsx';
import ProductCard from '../components/ProductCard.jsx';

// Example product detail (would be fetched from API in real app)
const product = {
  id: 1,
  image: '/images/baguette.jpg',
  title: 'Baguette Tradition',
  price: '1,20 €',
  tags: ['Pain', 'Tradition'],
  description: 'Notre baguette tradition est réalisée à partir de farines locales, pétrie et cuite sur place chaque jour pour une fraîcheur inégalée. Sa croûte dorée et sa mie aérée en font un incontournable de la maison Antic.'
};

export function ProductDetailPage() {
  return (
    <Container className="py-12 max-w-3xl">
      <div className="flex flex-col md:flex-row gap-8 items-center">
        <div className="w-full md:w-1/2">
          <img src={product.image} alt={product.title} className="rounded-xl shadow-lg w-full object-cover" />
        </div>
        <div className="w-full md:w-1/2">
          <h1 className="text-3xl font-heading font-bold text-primary mb-2">{product.title}</h1>
          <div className="flex flex-wrap gap-2 mb-2">
            {product.tags.map((tag) => (
              <span key={tag} className="bg-accent/10 text-accent px-2 py-1 rounded text-xs font-medium">{tag}</span>
            ))}
          </div>
          <div className="text-xl font-bold text-accent mb-4">{product.price}</div>
          <p className="text-text-secondary mb-6">{product.description}</p>
          <button className="btn-primary px-6 py-3 rounded-lg">Ajouter au panier</button>
        </div>
      </div>
      <SectionDivider />
    </Container>
  );
}

export default ProductDetailPage;
